const prefix = 'ROUTES_';

export const ACTUAL_ROUTES_GET_REQUEST = `${prefix}ACTUAL_ROUTES_GET_REQUEST`;
export const ACTUAL_ROUTES_GET_RECEIVED = `${prefix}ACTUAL_ROUTES_GET_RECEIVED`;
export const ACTUAL_ROUTES_GET_ERROR = `${prefix}ACTUAL_ROUTES_GET_ERROR`;

export const ACTUAL_DEPOT_ROUTES_GET_REQUEST = `${prefix}ACTUAL_DEPOT_ROUTES_REQUEST`;
export const ACTUAL_DEPOT_ROUTES_GET_RECEIVED = `${prefix}ACTUAL_DEPOT_ROUTES_RECEIVED`;
export const ACTUAL_DEPOT_ROUTES_ERROR = `${prefix}ACTUAL_DEPOT_ROUTES_ERROR`;

export const RECENT_ROUTES_GET_REQUEST = `${prefix}RECENT_ROUTES_GET_REQUEST`;
export const RECENT_ROUTES_GET_RECEIVED = `${prefix}RECENT_ROUTES_GET_RECEIVED`;
export const RECENT_ROUTES_GET_ERROR = `${prefix}RECENT_ROUTES_GET_ERROR`;

export const ROUTE_TEMPLATES_GET_REQUEST = `${prefix}ROUTE_TEMPLATES_GET_REQUEST`;
export const ROUTE_TEMPLATES_GET_RECEIVED = `${prefix}ROUTE_TEMPLATES_GET_RECEIVED`;
export const ROUTE_TEMPLATES_GET_ERROR = `${prefix}ROUTE_TEMPLATES_GET_ERROR`;

export const ROUTE_DECLARATION_FORM_INFORMATION_GET_REQUEST = `${prefix}ROUTE_DECLARATION_FORM_INFORMATION_GET_REQUEST`;
export const ROUTE_DECLARATION_FORM_INFORMATION_GET_RECEIVED = `${prefix}ROUTE_DECLARATION_FORM_INFORMATION_GET_RECEIVED`;
export const ROUTE_DECLARATION_FORM_INFORMATION_GET_ERROR = `${prefix}ROUTE_DECLARATION_FORM_INFORMATION_GET_ERROR`;

export const SWAP_INDEXES = `${prefix}SWAP_INDEXES`;
